import { useTranslation } from "react-i18next";
import { Tab } from "semantic-ui-react";

import { KIOSK_COMMUNICATION_STATUSES } from "models";
import { Content } from "modules/AppointmentDetails/components/KioskCommunicationLog/components";

import type { KioskCommunication } from "models";
import type { ReactNode } from "react";

type CommunicationsProps = {
  kiosk_communications: KioskCommunication[];
  defaultTabActiveIndex?: number;
};

type CommunicationPane = {
  menuItem: string;
  render: () => ReactNode;
};

export const Communications = ({ kiosk_communications, defaultTabActiveIndex = 0 }: CommunicationsProps) => {
  const { t } = useTranslation();
  const panes: CommunicationPane[] = [];

  kiosk_communications
    .sort((comm1, comm2) => comm2.created_on.localeCompare(comm1.created_on))
    .forEach((comm: KioskCommunication) => {
      panes.push({
        menuItem: comm.status === KIOSK_COMMUNICATION_STATUSES.CheckInOpened ? t("v8_opened", "Opened") : t("v8_answered", "Answered"),
        render: () => <Content comm={comm} />
      });
    });

  return panes.length > 0 ? <Tab menu={{ secondary: true }} panes={panes} defaultActiveIndex={defaultTabActiveIndex} /> : null;
};
